<!-- vee=validate regex https://medium.com/better-programming/how-to-use-vee-validate-to-do-form-validation-e01e9c8b6ac6 -->
<!-- https://medium.com/@lahin31/vee-validate-intro-and-example-22d8b95e25e1 
https://itsolutionstuff.com/post/laravel-vue-dependent-dropdown-exampleexample.html
:horizontal="true" inline the label and input
-->
<template>
<div class="container-fluid">
    <!-- <pre>changed: {{ this.params.wifi0_0_disabled }}</pre> -->
    <!-- <pre>Flags: {{ radioFlags }} {{ channelFlags }}</pre> -->
    <!-- <pre>VEE{{ this.veeFields }}</pre> -->
    <div class="card animated fadeIn">
        <b-form @submit.prevent="onSubmit()">
            <b-row>
                <b-col sm=6>
                    <b-card border-variant="light" v-if="config.snippet.wireless.wifi_device.radio0 != null">
                        <div slot="header">
                            <strong>2.4GHz Wireless</strong>
                        </div>
                        <b-form-group label="Radio:" label-for="wifi0_0_disabled">
                            <b-form-radio-group key="2.4GHz Radio" v-model="config.snippet.wireless.wifi_device.radio0.disabled" v-validate="'required'" data-vv-validate-on="change" id="wifi0_0_disabled" name="2.4GHz Radio" class="form-control" :class="{'is-invalid': submitted && verrors.has('2.4GHz Radio') }" :options="enableOptions" :disabled=!readonly></b-form-radio-group>
                            <div v-if="submitted && verrors.has('2.4GHz Radio')" class="invalid-feedback">{{ verrors.first('2.4GHz Radio') }}</div>
                        </b-form-group>
                        <b-form-group label="Channel:" label-for="wifi0_channel" v-if="config.snippet.wireless.wifi_device.radio0.disabled == '0'">
                            <b-form-select key="2.4Ghz Channel" v-model="config.snippet.wireless.wifi_device.radio0.channel" :options="channel24Options" v-validate="" data-vv-validate-on="change" id="wifi0_channel" name="2.4GHz Channel" class="form-control" :class="{'is-invalid': submitted && verrors.has('2.4GHz Channel') }" :disabled=!readonly>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label="SSID:" label-for="wifi0_0_ssid" v-if="config.snippet.wireless.wifi_device.radio0.disabled == '0'">
                            <b-form-input key="2.4GHz Wifi Network" type="text" v-model="config.snippet.wireless.wifi_iface.default_radio0.ssid" v-validate="'max:32'" id="wifi0_0_ssid" name="2.4GHz Wi-Fi Network" class="form-control" :class="{'is-invalid': submitted && verrors.has('2.4GHz Wi-Fi Network') }" :disabled=!readonly></b-form-input>
                            <div v-if="submitted && verrors.has('2.4GHz Wi-Fi Network')" class="invalid-feedback">{{ verrors.first('2.4GHz Wi-Fi Network') }}</div>
                            <!--            LEN: {{uniLen(config.snippet.wireless.wifi_iface.default_radio0.ssid)}}  {{rawLen(config.snippet.wireless.wifi_iface.default_radio0.ssid)}} -->
                        </b-form-group>
                        <b-form-group label="Passphrase:" label-for="wifi0_0_passphrase" v-if="config.snippet.wireless.wifi_device.radio0.disabled == '0'">
                            <b-form-input key="2.4GHz Passphrase" type="text" v-model="config.snippet.wireless.wifi_iface.default_radio0.key" v-validate="'min:8|max:32'" id="wifi0_0_passphrase" name="2.4GHz Passphrase" class="form-control" :class="{'is-invalid': submitted && verrors.has('2.4GHz Passphrase') }" :disabled=!readonly></b-form-input>
                            <div v-if="submitted && verrors.has('2.4GHz Passphrase')" class="invalid-feedback">{{ verrors.first('2.4GHz Passphrase') }}</div>
                        </b-form-group>
                        <!-- </b-form> -->
                    </b-card>
                </b-col>
                <b-col sm=6>
                    <b-card border-variant="light" v-if="config.snippet.wireless.wifi_device.radio1 != null">
                        <div slot="header">
                            <strong>5GHz Wireless</strong>
                        </div>
                        <b-form-group label="Radio:" label-for="wifi1_0_disabled">
                            <b-form-radio-group key="5GHz Radio" v-model="config.snippet.wireless.wifi_device.radio1.disabled" v-validate="'required'" data-vv-validate-on="change" id="wifi1_0_disabled" name="5GHz Radio" class="form-control" :class="{'is-invalid': submitted && verrors.has('5GHz Radio') }" :options="enableOptions" :disabled=!readonly></b-form-radio-group>
                            <div v-if="submitted && verrors.has('5GHz Radio')" class="invalid-feedback">{{ verrors.first('5GHz Radio') }}</div>
                        </b-form-group>
                        <b-form-group label="Channel:" label-for="wifi1_channel" v-if="config.snippet.wireless.wifi_device.radio1.disabled == '0'">
                            <b-form-select key="5Gh Channel" v-model="config.snippet.wireless.wifi_device.radio1.channel" :options="channel5Options" v-validate="" data-vv-validate-on="change" id="wifi1_channel" name="5GHz Channel" class="form-control" :class="{'is-invalid': submitted && verrors.has('5GHz Channel') }" :disabled=!readonly>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label="SSID:" label-for="wifi1_0_ssid" v-if="config.snippet.wireless.wifi_device.radio1.disabled == '0'">
                            <b-form-input key="5GHz Wifi Network" type="text" v-model="config.snippet.wireless.wifi_iface.default_radio1.ssid" v-validate="'max:32'" id="wifi1_0_ssid" name="5GHz Wi-Fi Network" class="form-control" :class="{'is-invalid': submitted && verrors.has('5GHz Wi-Fi Network') }" :disabled=!readonly></b-form-input>
                            <div v-if="submitted && verrors.has('5GHz Wi-Fi Network')" class="invalid-feedback">{{ verrors.first('5GHz Wi-Fi Network') }}</div>
                        </b-form-group>
                        <b-form-group label="Passphrase:" label-for="wifi1_0_passphrase" v-if="config.snippet.wireless.wifi_device.radio1.disabled == '0'">
                            <b-form-input key="5GHz Passphrase" type="text" v-model="config.snippet.wireless.wifi_iface.default_radio1.key" v-validate="'min:8|max:32'" id="wifi1_0_passphrase" name="5GHz Passphrase" class="form-control" :class="{'is-invalid': submitted && verrors.has('5GHz Passphrase') }" :disabled=!readonly></b-form-input>
                            <div v-if="submitted && verrors.has('5GHz Passphrase')" class="invalid-feedback">{{ verrors.first('5GHz Passphrase') }}</div>
                        </b-form-group>
                        <!-- </b-form> -->
                    </b-card>
                </b-col>
                <!--           <b-col sm=4>
            <b-card border-variant="light">
              <div slot="header">
                <strong>Tasks</strong>
              </div>
               <Tasks :device="device" :changed="changed" :changes="changes"></Tasks> 
            </b-card>
          </b-col> -->
            </b-row>
            <b-row>
                <b-col sm=12>
                    <div class="text-center">
                        <!-- TODO only activate when dirty -->
                        <button v-if="readonly" :disabled="verrors.any()" class="btn btn-primary">Add</button>
                    </div>
                </b-col>
            </b-row>
        </b-form>
    </div>
</div>
</template>

<script>
import { ValidationProvider, extend } from 'vee-validate';
import Multiselect from 'vue-multiselect';
import Tasks from "@/readynet/devices/network/Tasks";
import { mapFields } from 'vee-validate';

export default {
    components: {
        ValidationProvider,
        Multiselect,
        Tasks,

    },
    props: {
        config: {
            type: Object,
            // default: () =>([]),
        },

        changed: {
            type: Array,
            // default: () =>([]),
        },
        changes: {
            type: Object,
        },
    },

    watch: {

    },

    created() {
        // this.enabled24_value = this.device.wifi0_0_disabled;
        // this.channel24_value = this.device.wifi0_channel;
        // this.enabled5_value = this.device.wifi1_0_disabled;
        // this.channel5_value = this.device.wifi1_channel;
    },
    data() {
        return {

            submitted: false,
            enableOptions: [
                { text: 'Enabled', value: '0' },
                { text: 'Disabled', value: '1' },

            ],
            channel24Options: [
                { text: 'Auto', value: "auto" },
                { text: '1 (2412 Mhz)', value: "1" },
                { text: '2 (2417 Mhz)', value: "2" },
                { text: '3 (2422 Mhz)', value: "3" },
                { text: '4 (2427 Mhz)', value: "4" },
                { text: '5 (2432 Mhz)', value: "5" },
                { text: '6 (2437 Mhz)', value: "6" },
                { text: '7 (2442 Mhz)', value: "7" },
                { text: '8 (2447 Mhz)', value: "8" },
                { text: '9 (2452 Mhz)', value: "9" },
                { text: '10 (2457 Mhz)', value: "10" },
                { text: '11 (2462 Mhz)', value: "11" },
            ],
            channel5Options: [
                { text: 'Auto', value: "auto" },
                { text: '36 (5180 Mhz)', value: "36" },
                { text: '40 (5200 Mhz)', value: "40" },
                { text: '44 (5220 Mhz)', value: "44" },
                { text: '48 (5240 Mhz)', value: "48" },
                { text: '149 (5745 Mhz)', value: "149" },
                { text: '153 (5765 Mhz)', value: "153" },
                { text: '157 (5785 Mhz)', value: "157" },
                { text: '161 (5805 Mhz)', value: "161" },
                { text: '165 (5825 Mhz)', value: "165" },
            ],
            enabled24_flag: false,
            enabled24_value: '',

            channel24_flag: false,
            channel24_value: '',

            enabled5_flag: false,
            enabled5_value: '',
            channel5_flag: false,
            channel5_value: '',

        };
    },

    computed: {
        ...mapFields({
            radioFlags: '2.4GHz Radio'
        }),
        ...mapFields({
            channelFlags: '2.4GHz Channel'
        }),
        readonly() {
            return this.$can('config','edit')
        },
    },

    methods: {
        //What is this??
        hack1: function (value) {
            //console.log("hack 1 got:" + value)
            if (!this.enabled24_flag) {
                this.enabled24_value = value;
                this.enabled24_flag = true;
            }
            //console.log(" orig is: " + this.enabled24_value)
        },
        hack2: function (value) {
            //console.log("hack 2 got:" + value)
            if (!this.channel24_flag) {
                this.channel24_value = value;
                this.channel24_flag = true;

            }
        },
        hack3: function (value) {
            // console.log("hack 3 got:" + value)
            if (!this.enabled5_flag) {
                this.enabled5_value = value;
                this.enabled5_flag = true;

            }
        },
        hack4: function (value) {
            // console.log("hack 4 got:" + value)
            if (!this.channel5_flag) {
                this.channel5_value = value;
                this.channel5_flag = true;

            }
        },

        fancyCount2: function (str) {
            // function fancyCount2(str){
            const joiner = "\u{200D}";
            const split = str.split(joiner);
            let count = 0;

            for (const s of split) {
                //removing the variation selectors
                const num = Array.from(s.split(/[\ufe00-\ufe0f]/).join("")).length;
                count += num;
            }

            //assuming the joiners are used appropriately
            return count / split.length;
        },

        uniLen(s) {
            return [...s].length
        },
        rawLen(s) {
            return s.length
        },

        updateChanged(par, val, nam) {
            //console.log("Got:" + par + "|" + val + "|" + nam)
            for (var i = this.changed.length - 1; i >= 0; i--) {
                if (this.changed[i].param === par) {
                    this.changed.splice(i, 1);
                }
            }
            this.changed.push({ param: par, value: val, name: nam })
            this.$set(this.changes, par, val)
        },

        onSubmit() {
            this.submitted = true;

            this.$validator.validate().then(valid => {
                if (valid) {
                    // need to simplify this

                    // if (this.enabled24_value != this.device.wifi0_0_disabled && this.enabled24_flag) {
                    //   // console.log("X1 2.4 Radio flag " + this.enabled24_flag)
                    //   this.updateChanged("wifi0_0_disabled", this.config.snippet.wireless.wifi_iface.default_radio1.disabled, "2.4GHz Radio")
                    // } else if (this.enabled24_flag) {
                    //   // console.log("X2 2.4 Radio flag " + this.enabled24_flag);
                    //   this.updateChanged("wifi0_0_disabled", this.enabled24_value, "2.4GHz Radio")
                    // }
                    // if (this.channel24_value != this.device.wifi0_channel && this.channel24_flag) {
                    //   this.updateChanged("wifi0_channel", this.device.wifi0_channel, "2.4GHz Channel")
                    // } else if (this.channel24_flag) {
                    //   this.updateChanged("wifi0_channel", this.channel24_value, "2.4GHz Channel")
                    // }

                    if (this.veeFields['2.4GHz Radio'].dirty) {
                        this.updateChanged("wifi0_0_disabled", this.config.snippet.wireless.wifi_device.radio0.disabled, "2.4GHz Radio Disabled")
                    }
                    if (this.veeFields['2.4GHz Channel'].dirty) {
                        this.updateChanged("wifi0_0_channel", this.config.snippet.wireless.wifi_device.radio0.channel, "2.4GHz Radio Channel")
                    }
                    if (this.veeFields['2.4GHz Wi-Fi Network'].dirty) {
                        this.updateChanged("wifi0_0_ssid", this.config.snippet.wireless.wifi_iface.default_radio0.ssid, "2.4GHz Wi-Fi Network")
                    }

                    if (this.veeFields['2.4GHz Passphrase'].dirty) {
                        this.updateChanged("wifi0_0_passphrase", this.config.snippet.wireless.wifi_iface.default_radio0.key, "2.4GHz Passphrase")
                    }

                    // if (this.enabled5_value != this.device.wifi1_0_disabled && this.enabled5_flag) {
                    //   this.updateChanged("wifi1_0_disabled", this.device.wifi1_0_disabled, "5GHz Radio")
                    // } else if (this.enabled5_flag) {
                    //   console.log("X2 5 Radio flag " + this.enabled5_flag);
                    //   this.updateChanged("wifi1_0_disabled", this.enabled5_value, "5GHz Radio")
                    // }
                    // if (this.channel5_value != this.device.wifi1_channel && this.channel5_flag) {
                    //   this.updateChanged("wifi1_channel", config.snippet.wireless.wifi_device.radio1.channel, "5GHz Channel")
                    // } else if (this.channel5_flag) {
                    //   this.updateChanged("wifi1_channel", this.channel5_value, "5GHz Channel")
                    // }
                    if (this.config.snippet.wireless.wifi_device.radio1 != null) {
                        if (this.veeFields['5GHz Radio'].dirty) {
                            this.updateChanged("wifi1_0_disabled", this.config.snippet.wireless.wifi_device.radio1.disabled, "5GHz Radio Disabled")
                        }
                        if (this.veeFields['5GHz Channel'].dirty) {
                            this.updateChanged("wifi1_0_channel", this.config.snippet.wireless.wifi_device.radio1.channel, "5GHz Radio Channel")
                        }
                        if (this.veeFields['5GHz Wi-Fi Network'].dirty) {
                            this.updateChanged("wifi1_0_ssid", this.config.snippet.wireless.wifi_iface.default_radio1.ssid, "5GHz Wi-Fi Network")
                        }
                        if (this.veeFields['5GHz Passphrase'].dirty) {
                            this.updateChanged("wifi1_0_passphrase", this.config.snippet.wireless.wifi_iface.default_radio1.key, "5GHz Passphrase")
                        }
                    }

                } else {
                    console.log("Wifi submitted, INVALID");
                }
            });
        },

    },

};
</script>
